import styled from 'styled-components';

import { getPurpurColor, purpurMedia } from '@telialt/common-theme/src/purpurSelectors';
import {
    NAVIGATION_OFFSET_CSS_VARIABLE,
    NAVIGATION_OFFSET_TRANSITION_CSS_VARIABLE,
} from '@telialt/utils/src/NavigationUtils/constants';

import { MAGNIFYING_GLASS_BORDER_SIZE, MAGNIFYING_GLASS_FRAME_SIZE, Z_INDEX } from './constants';

export const PositioningContainer = styled.div<{
    $isHidden: boolean;
}>`
    display: none;
    position: sticky;
    top: var(${NAVIGATION_OFFSET_CSS_VARIABLE});
    transition: var(${NAVIGATION_OFFSET_TRANSITION_CSS_VARIABLE});
    right: auto;
    z-index: ${Z_INDEX};

    ${({ $isHidden }) => purpurMedia('lg')`
        display: ${$isHidden ? 'none' : 'block'};
    `};
`;

export const MagnifyingGlassFrame = styled.div`
    position: absolute;
    border: solid ${MAGNIFYING_GLASS_BORDER_SIZE}px ${getPurpurColor('gray50')};
    background-color: white;
    height: ${MAGNIFYING_GLASS_FRAME_SIZE}px;
    width: 100%;
    overflow: hidden;
`;
